import type * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/utils/cn"

const badgeVariants = cva(
  "inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-input bg-background text-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "border-input text-foreground",
        muted:
          "border-transparent bg-muted text-muted-foreground",
        // Sprint 4 Prep — editorial accent variants for Sprint 4a/4c pill grammar
        success:
          "border-transparent bg-moss-soft text-moss",
        warning:
          "border-transparent bg-amber-soft text-amber",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

// eslint-disable-next-line react-refresh/only-export-components -- non-component export alongside a component (affects dev fast-refresh only); file split is out of scope for CUR-1330
export { Badge, badgeVariants }
